import { StyleSheet } from 'aphrodite/no-important';

export const styles = StyleSheet.create({
    hidden: {
        position: 'fixed',
        zIndex: '-1',
        border: 'none',
        opacity: 0,
    }
});


// WEBPACK FOOTER //
// ./react-app-src/videoPlayer/components/styles/VideoShareStyles.js